import { datadogLogs } from '@datadog/browser-logs'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import packageJson from '../../../../package.json'

export function initializeLoggingService() {
  datadogLogs.init({
    clientToken: process.env.NEXT_PUBLIC_LOGS_DATADOG_CLIENT_TOKEN || '',
    env: process.env.NEXT_PUBLIC_DATADOG_ENV,
    service:
      process.env.NEXT_PUBLIC_DATADOG_ENV === 'production'
        ? 'shop-2.0-prod'
        : 'shop-2.0-qa',
    sessionSampleRate: 100,
    site: 'us5.datadoghq.com',
    version: packageJson.version,
    forwardErrorsToLogs: false,
  })
}

export function generateCurlCommand(
  method: string,
  url: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers: { [key: string]: any },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestData: { [key: string]: any },
) {
  let curlCommand = `curl -X ${method} '${url}'`
  for (const [key, value] of Object.entries(headers)) {
    if (key === '') {
      // eslint-disable-next-line no-continue
      continue
    }
    curlCommand += ` -H '${key}: ${value}'`
  }

  curlCommand += ` -d '${JSON.stringify(requestData)}'`

  return curlCommand
}

export function logRequestResponse({
  request,
  response,
  curl,
  requestName,
  error = null,
}: {
  request: SendRequestType
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: { [key: string]: any }
  curl: string
  requestName: string
  error: string | null
}) {
  const logEntry = {
    timestamp: new Date().toISOString(),
    request,
    response,
    requestName,
    error: error || null,
    curl,
  }
  if (response.status >= 400) {
    return datadogLogs.logger.error(`FAILED: ${requestName}`, logEntry)
  }
  return datadogLogs.logger.log(requestName, { ...logEntry })
}

export function logError(error: string | object, requestName: string) {
  const logEntry = {
    timestamp: new Date().toISOString(),
    requestName,
    error:
      typeof error === 'object'
        ? JSON.stringify(error, null, 2)
        : String(error),
  }

  datadogLogs.logger.error(`FAILED: ${requestName}`, logEntry)
}
